/* eslint-disable one-var */
/* eslint-disable max-statements */

jQuery(document).ready(function($) {
  'use strict';

  if ($('.ipo-mdc-question-circle').length) {
    $('.ipo-mdc-question-circle').on('click', function(e) {
      const naam = $(this).children('.ipo-mdc-question-info')
        .attr('name')
        .split('-')[0];

        const classToToggle = naam + '-question-info';

        $('.ipo-mdc-question-info[name!=' + classToToggle + ']').each(function() {
          if (!$(this).hasClass('hide-info')) {
            $(this).addClass('hide-info');
          }
        });

        $('[name=' + classToToggle + ']').toggleClass('hide-info');
        e.stopPropagation();
    });

    $(document).on('click', function() {
      $('.ipo-mdc-question-info').each(function() {
        if (!$(this).hasClass('hide-info')) {
          $(this).addClass('hide-info');
        }
      });
    });
  }
});
